import * as Yup from 'yup';

export const validationPharmacySchema = Yup.object().shape({
  packageId: Yup.string().nullable(),
  items: Yup.array().of(
    Yup.object().shape({
      prescribedStrength: Yup.string().nullable(),
      prescribedQty: Yup.number()
        .min(1, 'Quantity must be at least 1')
        .required('Prescribed quantity is required'),
      prescribedUOM: Yup.string().required('Prescribed UOM is required'),
      billedStrength: Yup.string().nullable(),
      batchCode: Yup.string().required('Batch code is required'),
      billedQty: Yup.number()
        .min(1, 'Quantity must be at least 1')
        .required('Billed quantity is required'),
      billedUOM: Yup.string().required('Billed UOM is required'),
    })
  ).min(1, 'At least one item is required'),
  concessionReason: Yup.string().nullable(),
  dueDate: Yup.string().nullable(),
  termsAndConditions: Yup.string().nullable(),
  legalMentions: Yup.string().nullable(),
  remark: Yup.string().nullable(),
  comments: Yup.string().nullable(),
});